// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"fdf7fca3e83ae61fd2fa","678":"19c9e40db941e373bcfd","731":"97b6852d4bce55562c68","843":"720ed69d2fc03e5ec14f","883":"900e59f8d443c3e1ce21"}[chunkId] + ".js";
};